export default "__VITE_PUBLIC_ASSET__75770240__"